import { ComponentConfig } from "@measured/puck"
import { configs, DefaultImage } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"

export interface FooterProps extends CommonStylesProps {
  logo?: string
  nameCompany?: string
  branchCompany?: {
    name?: string
    address?: string
  }[]
  contact?: {
    icon?: string
    label?: string
    url?: string
  }[]
  introduce?: {
    label?: string
    item?: {
      label?: string
      url?: string
    }[]
  }
  followUs?: {
    label?: string
    item?: {
      icon?: string
      url?: string
    }[]
  }
}

export const RenderCareersFooter: ComponentConfig<FooterProps> = {
  render: ({ nameCompany, branchCompany, contact, followUs, introduce, logo }) => {
    return (
      <div
        className=" w-full p-[90px] pt-[90px] relative overflow-hidden max-sm:p-0"
        style={{
          backgroundImage: "./images/bg-footer.png",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          display: "block",
        }}
      >
        <img alt="" src={"./images/bg-footer.png"} className="absolute -z-10 left-[10px] top-[0px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[160px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[320px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[480px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[640px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[700px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[880px]" />
        <img alt="" src={"./images/bg-footer.png"} className="md:hidden absolute -z-10 left-[10px] top-[1040px]" />
        <div className="max-w-[1170px] w-full px-[15px] mx-auto max-sm:pr-[6px] max-sm:pt-[40px]">
          <div className="flex flex-row max-sm:flex-col">
            <div className="w-[40%] max-sm:w-full">
              <div className="md:pt-[5px]">
                <img src={logo ? `${configs.API_URL}${logo}` : DefaultImage} width={230} alt="logo" />
              </div>

              <div className="bg-white border border-[#dcdcdc] p-[3px] rounded-[10px] mt-[20px] w-[82%] ml-[-5px] max-sm:w-full">
                <div className="flex flex-col p-[14px] bg-[#f8f8f8] rounded-[10px] border border-[#dcdcdc] text-[#283248] mb-[5px] gap-[5px]">
                  {nameCompany && (
                    <p>
                      <b>{nameCompany}</b>
                    </p>
                  )}

                  {branchCompany && branchCompany.length > 0 && (
                    <>
                      {branchCompany.map((item, index) => (
                        <p key={index}>
                          <b>{item.name}</b> <br />
                          {item.address}
                        </p>
                      ))}
                      <p></p>
                    </>
                  )}
                </div>
              </div>
              <div className="border border-[#dcdcdc] p-[3px] rounded-[10px] mt-[20px] w-[82%] shadow-[1px_1px_2px_4px_#fefefe] ml-[-5px] max-sm:w-full max-sm:mb-[35px]">
                <div className="flex flex-col p-4 bg-[#f8f8f8] rounded-[10px] border border-[#dcdcdc] text-[#283248]  gap-[5px]">
                  {contact && contact.length > 0 && (
                    <>
                      {contact.map((item, index) => (
                        <p key={index} className="flex gap-[12px]">
                          <img
                            src={item.icon ? `${configs.API_URL}${item.icon}` : DefaultImage}
                            alt="logo-contact"
                            className="pt-[4px] ml-[-1px]"
                          />
                          <a href={item.url ?? ""}>{item.label}</a>
                        </p>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[30%] max-sm:w-full max-sm:mb-[35px]">
              <h3 className="font-bold text-[20px]">{introduce?.label}</h3>
              <div className="mt-[23px] mb-[14px] text-black section-gioi-thieu">
                {introduce?.item &&
                  introduce.item.length > 0 &&
                  introduce.item.map((item, index) => (
                    <p key={index} className="mb-[10px]">
                      <a href={item.url ?? ""}>{item.label}</a>
                    </p>
                  ))}
              </div>
            </div>
            <div className="w-[30%] max-sm:w-full max-sm:mb-[85px]">
              <h3 className="font-bold text-[20px] mb-[7px] ">{followUs?.label}</h3>
              <div className="mt-[37px] flex gap-[25px]">
                {followUs?.item &&
                  followUs.item.length > 0 &&
                  followUs.item.map((item, index) => (
                    <a key={index} href={item.url ?? ""}>
                      <img src={item.icon ? `${configs.API_URL}${item.icon}` : DefaultImage} width={25} alt="logo" />
                    </a>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  },
}
